import { PageBlockEditorModelV2, PageSectionEditorModelV2 } from "../elements";
import { z } from "zod";
export const DocumentationPageContentItem = z.discriminatedUnion("type", [
    PageBlockEditorModelV2,
    PageSectionEditorModelV2,
]);
export const DocumentationPageContentData = z.object({
    items: z.array(DocumentationPageContentItem),
});
export const DocumentationPageContent = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    documentationPageId: z.string(),
    data: DocumentationPageContentData,
});
